<template>
  <div id="app" :route="$route.name">
    
    <div class="contenedor-view">
      <router-view class="view"/>
    </div>
  
  </div>
</template>

<script>

  require('waypoints/lib/noframework.waypoints.js')

  import CookieLaw from 'vue-cookie-law'

  export default {
    name: 'App',
    components : {

      'cookie-law' : CookieLaw
    },
  }
</script>

<style  lang="scss">
  @import '@/assets/css/colors.scss';
  @import './assets/css/animaciones.scss';
  @import './assets/css/style.scss';
  @import './assets/css/responsive.scss';
  @import './assets/css/slick.css';
  @import "splitting/dist/splitting.css";
  @import url('https://fonts.googleapis.com/css?family=Roboto:300,400,600,700');
  @import url(https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css);
  @import url(https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.7.1/animate.css);
</style>



// WEBPACK FOOTER //
// src/App.vue